<template>
  <div>
    <b-row>
      <b-col></b-col>
      <b-col>
        <b-card title="Ingreso a SisCol">
            <hr />
            <b-form @submit.prevent="login">
                <b-form-group label-for="usuario" label="Usuario" label-size="lg" class="mt-5">
                    <b-form-input id="usuario" v-model="usuario" placeholder="Usuario" size="lg" autocomplete="off" trim required></b-form-input>
                </b-form-group>
                <b-form-group label-for="password" label="Contraseña" label-size="lg">
                    <b-form-input id="password" v-model="password" type="password" placeholder="Contraseña" size="lg" class="mb-5" required></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="info" size="lg" class="my-3 btn-block">Ingresar</b-button>
            </b-form>
        </b-card>
      </b-col>
      <b-col></b-col>
    </b-row>
  </div>    
</template>
<script>
import {mapMutations} from 'vuex'
export default {
    name: 'Login',
    data() {
        return {
            usuario: '',
            password: ''
        }
    },
    methods: {
        ...mapMutations(['registrarToken','registrarUser']),
        login() {
            const {usuario, password} = this
            /*if (usuario === 'demo' & password === 'demo') {
                this.registrarUser(usuario)
                this.usuario = ''
                this.password = ''
                this.$router.push('/docs')
            }*/
            this.axios.post('/usuarios/autenticar', {'user': usuario, password})
                .then (res => {
                    this.registrarToken(res.data.token)
                    //console.log('Token:', res.data.token)
                    this.axios.defaults.headers.common['Authorization'] = 'Bearer '+res.data.token
                    //console.log('Cabecera:',this.axios.defaults.headers.common['Authorization'])
                    this.registrarUser(usuario)
                    this.usuario = ''
                    this.password = ''
                    this.$router.push('/docs')
                })
                .catch(e => {
                    console.log(e)
                })
        }
    }
}
</script>